import PropTypes from "prop-types";
import PieChart from "./PieChart";

function SatisfaccionPorRango({ data }) {
    return (
    <PieChart
      data={data}
      title="Satisfacción por Rango"
      height={300}
      legendPosition="right"
      showPercentage={true}
      noDataMessage="No hay datos de satisfacción para el período seleccionado"
      colors={{
        background: [
          "rgba(220, 53, 69, 0.8)", // Rojo para Muy Bajo
          "rgba(255, 159, 64, 0.8)", // Naranja para Bajo
          "rgba(255, 193, 7, 0.8)", // Amarillo para Medio
          "rgba(40, 167, 69, 0.8)", // Verde para Alto
        ],
        border: [
          "rgb(220, 53, 69)",
          "rgb(255, 159, 64)",
          "rgb(255, 193, 7)",
          "rgb(40, 167, 69)",
        ]
      }}
    />
  );
}

SatisfaccionPorRango.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.number)
  })
};

export default SatisfaccionPorRango;